var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"dragRef",staticClass:"fixed drag-block",style:({ ..._setup.style, zIndex: _setup.props.zIndex }),on:{"mousedown":_setup.handleMouseDownBall,"mouseup":_setup.handleMouseUpBall}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }